export default __webpack_public_path__ + "static/media/B_01_01_map.3ee786cf.jpg";